module.exports = __webpack_public_path__ + "img/30.3333b610.svg";